import {
  COMBINED_ENTRY_PAGE_LOADED,
  COMBINED_RESULTS_LOADED,
} from '@web-platform/shared-universal-constants/src/redux/actions/render';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { InteractionsState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/interactions';

export type { InteractionsState };

const getInitialState = () => ({
  originSelected: false,
  destinationSelected: false,
  datesSelected: false,
});

const interactions = (
  state: InteractionsState = getInitialState(),
  action: Action,
): InteractionsState => {
  switch (action.type) {
    case COMBINED_RESULTS_LOADED:
    case COMBINED_ENTRY_PAGE_LOADED: {
      return { ...state, originSelected: true, destinationSelected: true, datesSelected: true };
    }

    default:
      return state;
  }
};

export default interactions;
export const get = (state: InteractionsState): InteractionsState => state;
